




























































import {
  defineComponent,
  ref,
  onMounted,
  useContext,
} from '@nuxtjs/composition-api';
import { CookieConsentState } from '@wemade-vsf/cookie-consent';
import { SfButton, SfCheckbox } from '@storefront-ui/vue';

export default defineComponent({
  name: 'CookieConsentBanner',
  components: {
    SfButton,
    SfCheckbox
  },
  setup () {
    const { app } = useContext();
    const showBanner = ref(false);
    const showDetails = ref(false);

    const options = ref<CookieConsentState>({
      analytics: true,
      marketing: true,
      preferences: true,
    })

    function acceptAll () {
      const consent = app.$cookieConsent;
      if (consent?.updateConsent) {
        consent.updateConsent({
          analytics: true,
          marketing: true,
          preferences: true,
        })
      }
      showBanner.value = false;
    }

    function acceptCustom () {
      const consent = app.$cookieConsent;
      if (consent?.updateConsent) {
        consent.updateConsent(options.value)
      }
      showBanner.value = false;
    }

    onMounted(() => {
      const consent = app.$cookieConsent;
      if (!consent) return;
      if (!consent?.consented.value) {
        options.value = consent.consentState.value as CookieConsentState;
        showBanner.value = true;
      } else {
        consent.updateConsent(consent.consentState.value as CookieConsentState)
      }
    })

    return {
      options,
      acceptCustom,
      acceptAll,
      showBanner,
      showDetails
    }
  }
})
